import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

/**
 * DeepDiveSheet — slide-over for KpiTile click-through.
 *
 * Reuses the existing shadcn `Sheet` primitive (no new component).
 * Caller passes `children` — typically a table of the underlying rows
 * that compose the metric. Keep the body simple: tables, not charts.
 *
 * Default side = "right", width 480px (matches tile strip proportions).
 */
export function DeepDiveSheet({ open, onOpenChange, title, description, children }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-[480px] overflow-y-auto"
        data-testid="kpi-deep-dive-sheet"
      >
        <SheetHeader>
          <SheetTitle className="font-black uppercase tracking-tight text-2xl">
            {title}
          </SheetTitle>
          {description && (
            <SheetDescription className="font-mono text-xs">
              {description}
            </SheetDescription>
          )}
        </SheetHeader>
        <div className="mt-6 space-y-4">
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default DeepDiveSheet;
